import React from "react";
import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { PHONE_NUMBER, PHONE_TEL } from "../../config/siteConfig";

export const HomeHeader = () => (
  <header className="border-b border-white/10 bg-slate-950/90 backdrop-blur sticky top-0 z-50">
    <div className="mx-auto max-w-7xl px-6 py-4 flex items-center justify-between">
      <Link to="/" className="text-xl font-semibold tracking-wide" data-testid="header-logo">
        Social Dispute Co
      </Link>
      <nav className="hidden md:flex items-center gap-6 text-sm text-slate-300">
        <a href="#services" className="hover:text-white transition-colors">Services</a>
        <a href="#how-it-works" className="hover:text-white transition-colors">How It Works</a>
        <a href="#pricing" className="hover:text-white transition-colors">Pricing</a>
        <a href="#faq" className="hover:text-white transition-colors">FAQ</a>
      </nav>
      <div className="flex items-center gap-3">
        <a
          href={PHONE_TEL}
          className="hidden sm:flex items-center gap-2 text-sm text-slate-300 hover:text-white transition-colors"
          data-testid="header-phone"
          aria-label={`Call us at ${PHONE_NUMBER}`}
        >
          <Phone className="w-4 h-4" />
          {PHONE_NUMBER}
        </a>
        <Link
          to="/contact"
          className="rounded-full bg-white text-slate-950 px-5 py-2.5 text-sm font-semibold shadow-lg hover:bg-slate-100 transition"
          data-testid="header-cta"
        >
          Free Assessment
        </Link>
      </div>
    </div>
  </header>
);
